module.exports = __webpack_public_path__ + "fonts/FuturaPT-Demi.57b3d1b6.woff2";